'use strict';

const formLabelTokens = (theme) => ({
    formLabelLetterSpacing: theme.typography.letterSpacing.m,
    formLabelTextColor: theme.colors.body.text,
    formLabelBackgroundColor: theme.colors.body.background,
    formLabelFontFamily: theme.typography.fontFamily.regular,
    formLabelFontSize: theme.typography.fontSize.s,
    formLabelLineHeight: theme.typography.lineHeight.s,
    formLabelFontWeight: theme.typography.fontWeight.semibold,
    formLabelRequiredIndicatorColor: theme.colors.danger.normal,
});

exports.formLabelTokens = formLabelTokens;
//# sourceMappingURL=formLabel.js.map
